import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import WorkspacesOutlinedIcon from '@mui/icons-material/WorkspacesOutlined';
// import PersonRemoveOutlinedIcon from '@mui/icons-material/PersonRemoveOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';

export const tutorDashboardCardMapper = [
  {
    id: 1,
    icon: <PersonAddOutlinedIcon sx={{ color: '#2563EB', fontSize: 28 }} />,
    iconBgColor: '#EEF3FF',
    title: 'Current Month Onboarded Tutors',
    value: 'currentMonthOnBoardTutorsCount',
    type: 'onboarding',
  },
  {
    id: 2,
    icon: <AccessTimeOutlinedIcon sx={{ color: '#16A34A', fontSize: 28 }} />,
    iconBgColor: '#E7F7ED',
    title: 'Tutor Slots Utilized',
    value: 'tutorSlotsUtilizedPercentage',
    // percentage: true,
    type: 'slot_utlized',
  },
  {
    id: 3,
    icon: <MenuBookOutlinedIcon sx={{ color: '#9333EA', fontSize: 28 }} />,
    iconBgColor: '#F3E8FF',
    title: 'Most Assigned Subject',
    value: 'mostAssignedSubjects',
    noInfo: true,
  },
  {
    id: 4,
    icon: <PersonOffOutlinedIcon sx={{ color: '#DC2626', fontSize: 28 }} />,
    iconBgColor: '#FEE2E2',
    title: 'Zero-Session Tutors',
    value: 'zeroSessionTutorsCount',
    type: 'zero_session',
  },
  {
    id: 5,
    icon: <GroupsOutlinedIcon sx={{ color: '#4F46E5', fontSize: 28 }} />,
    iconBgColor: '#EEF2FF',
    title: 'Current Tutor Pool',
    value: 'totalActiveTutors',
    type: 'tutor_pool',
  },
  {
    id: 6,
    icon: <WorkspacesOutlinedIcon sx={{ color: '#F97316', fontSize: 28 }} />,
    iconBgColor: '#FFF7ED',
    title: 'CRO-wise Assignment',
    value: 'croWiseAssignment',
    type: 'cro_wise',
  },
  /* {
    id: 7,
    icon: <PersonRemoveOutlinedIcon sx={{ color: '#F43F5E', fontSize: 28 }} />,
    iconBgColor: '#FFE4E6',
    title: 'Terminated Tutors',
    value: '12',
  } */
  {
    id: 8,
    icon: <LogoutOutlinedIcon sx={{ color: '#6B7280', fontSize: 28 }} />,
    iconBgColor: '#F3F4F6',
    title: 'Tutor Exits',
    value: 'totalResignedTrainers',
    type: 'resigned',
  },
  {
    id: 9,
    icon: <SchoolOutlinedIcon sx={{ color: '#0891B2', fontSize: 28 }} />,
    iconBgColor: '#ECFEFF',
    title: 'Internship',
    value: 'intersCount',
    type: 'intern',
  },
];
